// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* filepath: src/components/Login.css */
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f0f2f5;
}

.login-form {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    text-align: center;
}

.login-logo {
    width: 100px;
    margin-bottom: 1.5rem;
}

.login-form h2 {
    margin-bottom: 1.5rem;
    color: #333;
}

.form-group {
    margin-bottom: 1rem;
    text-align: left;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
}

.form-group input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.login-button {
    width: 100%;
    padding: 0.75rem;
    background-color: #00bf06;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.login-button:hover {
    background-color: #007803;
}

.error-message {
    color: white;
    background-color: rgba(255, 0, 0, 0.717);
    padding: 0.5rem;
    border-radius: 4px;
    margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":["/* filepath: src/components/Login.css */\r\n.login-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background-color: #f0f2f5;\r\n}\r\n\r\n.login-form {\r\n    background: white;\r\n    padding: 2rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    width: 100%;\r\n    max-width: 400px;\r\n    text-align: center;\r\n}\r\n\r\n.login-logo {\r\n    width: 100px;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.login-form h2 {\r\n    margin-bottom: 1.5rem;\r\n    color: #333;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 1rem;\r\n    text-align: left;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 0.5rem;\r\n    color: #555;\r\n}\r\n\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\n.login-button {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n    background-color: #00bf06;\r\n    border: none;\r\n    border-radius: 4px;\r\n    color: white;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n}\r\n\r\n.login-button:hover {\r\n    background-color: #007803;\r\n}\r\n\r\n.error-message {\r\n    color: white;\r\n    background-color: rgba(255, 0, 0, 0.717);\r\n    padding: 0.5rem;\r\n    border-radius: 4px;\r\n    margin-bottom: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
